// 截流
export function throttle(fun, time) {
    let timer = null
    const _this = this
    return function(...other) {
        if (timer) {
            clearTimeout(timer)
        } 
        timer = setTimeout(() => {
            fun.apply(_this, other)
            timer = null
        }, time)
    }
}

export function setTargetKeyNull(target, keys = []) {
    if (Object.prototype.toString.apply(target) === '[object Array]') {
        return target.map(item => {
            return setTargetKeyNull(item, keys)
        }) 
    }
    if (Object.prototype.toString.apply(target) === '[object Object]') {
        const new_obj = {}
        Object.keys(target).forEach(key => {
            if (keys.includes(key)) {
                new_obj[key] = null
            } else {
                new_obj[key] = setTargetKeyNull(target[key], keys)
            }
        })
        return new_obj
    }
    return target
}